export function matchesPattern(pattern: string) {
	return (name: string, values: Record<string, unknown>) => {
		const value = values[name];
		if (typeof value === 'string') {
			return new RegExp(pattern).test(value);
		}
		return false;
	};
}
